import { Component } from '@angular/core';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { ToastrService } from 'toastr-ng2';


@Component({
  selector: 'app-add-notification',
  templateUrl: './add-notification.component.html',
  styleUrls: ['./add-notification.component.scss']
})
export class AddNotificationComponent  {

   url:any='';
     news:any={}
         newsData: FirebaseListObservable<any>;
 imageId: string;

    uploader: CloudinaryUploader = new CloudinaryUploader(
        new CloudinaryOptions({ cloudName: 'ocomedia', uploadPreset: 'ui0cyga0' })
    );

    constructor(public af:AngularFireDatabase, public router:Router,public toastr: ToastrService) {
     this.newsData = af.list('/FoonYew2');
        //Override onSuccessItem to retrieve the imageId
           this.uploader.onAfterAddingFile = (item: any) => {
            item.url = this.uploader.options.url;
            return item;
        };
       
    }

    //Image Preview
      readUrl(event) {
                 if (event.target.files && event.target.files[0]) {
                 var reader = new FileReader();
               reader.onload = (event:any) => {
                 this.url = event.target.result;
                 //this.imageRef = 1;
               }

             reader.readAsDataURL(event.target.files[0]);
             }
           }

           //Submit function
    onSubmitNews(form: NgForm){
       this.uploader.uploadAll();
        this.uploader.onSuccessItem = (item: any, response: string, status: number, headers: any): any => {
            let res: any = JSON.parse(response);
            this.news.featuredImageURL = res.url;
    	          this.newsData.push(this.news).then((res)=>{
                    this.toastr.success('Notificaiotn Data Added Successfully!', 'Success!');
          this.router.navigate(['/notification/manageNotification']);
        });
      }
    }
    cancel(){
       this.router.navigate(['/notification/manageNotification']);
    }
}




// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/notifications/add-notification/add-notification.component.ts